import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full flex flex-col gap-1.5" data-id="element-488">
        {label && <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest" data-id="element-489">
            {label}
          </label>}
        <textarea ref={ref} className={`flex min-h-[80px] w-full rounded-none border border-border bg-background px-3 py-2 font-mono text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} data-id="element-490" />
        {error && <span className="font-mono text-xs text-destructive" data-id="element-491">{error}</span>}
      </div>;
});
Textarea.displayName = 'Textarea';